import '../assets/css/main.css';
import NavBar from "../components/navbar";
import Footer from "../components/footer";

function Registration() {

    return (
        <>
            <NavBar/>
            <main className="main">
                <section id="starter-section" className="contact section">
                    <div className="container section-title" data-aos="fade-up">
                        <h2>Registration</h2>
                        <p>Use the registration tool below in order to register your copy of the purchased work in order to obtain a digital version of the work and/or digital versions of the part extracts.</p>
                    </div>
                    <div className="container" data-aos="fade-up">
                        <div className="row gy-4" style={{margin: "auto", width: "75%"}}>
                            <div className="col-lg-7" style={{margin: "auto", width: "fit-content"}}>
                                <form action="forms/contact.php" method="post" className="php-email-form" data-aos="fade-up" data-aos-delay="200">
                                    <div className="row gy-4">
                                        <div className="col-md-6">
                                            <label className="pb-2">Your Name</label>
                                            <input type="text" name="name" id="name-field" className="form-control" required={true} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="pb-2">Your Email</label>
                                            <input type="email" className="form-control" name="email" id="email-field" required={true}/>
                                        </div>
                                        <div className="col-md-12">
                                            <label className="pb-2">Registration Code</label>
                                            <input type="text" className="form-control" name="subject" id="subject-field" required={true} />
                                        </div>
                                        <div className="col-md-12 text-center">
                                            <div className="loading">Loading</div>
                                            <div className="error-message"></div>
                                            <div className="sent-message">Your message has been sent. Thank you!</div>
                                            <button type="submit">Submit Registration</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer/>
        </>
    )
}

export default Registration;